import MotivationCommunication from '~/pages/communication/motivation/libs/components/MotivationCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const MotivationCommunicationPage = (props: TPageProps) => (
  <MotivationCommunication {...props} />
)

export default MotivationCommunicationPage
